import React, { memo } from "react";
import styles from "./Logo.module.css";
import { useSelector } from "react-redux";

const Logo = memo(({ className, size = "default", customSize }) => {
  const logoStyle = customSize ? { maxHeight: `${customSize}px` } : {};

  // Build logo URL from Redux setting and .env base URL
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(
    /\/$/,
    ""
  );
  const logoPath = useSelector(
    (s) =>
      s.user?.websiteSetting?.data?.[0]?.logoUrl ??
      s.user?.websiteSetting?.[0]?.logoUrl ??
      s.user?.websiteSetting?.logoUrl
  );
  const logoSrc = logoPath
    ? logoPath.startsWith("http")
      ? logoPath
      : `${apiBaseUrl}${logoPath.startsWith("/") ? "" : "/"}${logoPath}`
    : `${apiBaseUrl}/mocklogo.png`;

  return (
    <div className={`${styles.logoSection} ${className || ""}`}>
      <img
        src={logoSrc}
        alt="Logo"
        className={`${styles.logo} ${customSize ? "" : styles[size]}`}
        style={logoStyle}
      />
    </div>
  );
});

Logo.displayName = "Logo";

export default Logo;
